<template>
  <div class="division">
    <div class="tab_wrap">
      <input id="tab1" type="radio" name="tab_btn" checked @click="$emit('change-participate-type', 'real')">
      <input id="tab2" type="radio" name="tab_btn" @click="$emit('change-participate-type', 'online')">
      <div class="tab_area">
        <!-- デフォルト。中止時はオンラインがデフォルト -->
        <label class="tab1_label" for="tab1">当日会場に来る</label>
        <label class="tab2_label" for="tab2">オンラインで参加する</label>
      </div>
    </div>
    <!-- <div class="leaflet">
      <img class="img" src="/img/leaflet.png">
      <a class="link" href="">当日リーフレット</a>
    </div> -->
    <div class="explanation" v-show="!isReal">
      <ul class="flex">
        <li class="txtbox"><p class="title">プレゼントキーワード付き企業LIVE</p><p class="message">LIVEに参加して3つキーワードを集めよう！<br>キーワードを集めた後は抽選会に応募しよう（締切 15:15）</p></li>
        <li class="imgbox"><img class="sendaiimg" src="/img/top/company.png"></li>
      </ul>
      <ul class="flex">
        <li class="txtbox"><p class="title">学び・遊び体験LIVE</p><p class="message">ママ主催者による楽しい「学び・体験・遊びLIVE」ひとりで、親子で、気軽に参加しよう♪</p></li>
        <li class="imgbox"><img class="sendaiimg" src="/img/top/provider.png"></li>
      </ul>
    </div>
    <div class="inner anytime" v-show="!isReal">
      <p class="title2">いつでも参加できるイベント</p>
      <p class="message2">企業ブースを回って、スタンプラリー抽選会に参加しよう♪抽選会では豪華賞品が当たります！</p>
      <div class="live-programs">
        <LiveProgram09
          class="card"
          v-for="(program, idx) in displayAlwaysEvents"
          :key="program.id + idx"
          :program="program"
          liveType="company"
          :month="month"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LiveProgram09 from '@/components/molecules/202009sendai/LiveProgram.vue'

export default {
  props: {
    isReal: Boolean,
    month: String
  },
  components: {
    LiveProgram09
  },
  computed: {
    ...mapGetters([
      'companyLive0915'
    ]),
    displayAlwaysEvents () {
      return this.companyLive0915.filter((item, idx) => {
        return item.isAlwaysViewable
      })
    }
  }
}
</script>
<style lang="sass" scoped>
.division
  text-align: center
  max-width: 600px
  margin: 0 auto 0 auto
  width: 100%
  background: #FCF4F7
  padding: 30px 0
input[type="radio"]
  display: none
.tab_area
  font-size: 0
  margin: 0 10px
.tab_area label
  margin: 0 10px
  display: inline-block
  padding: 15px
  color: #00AC3D
  text-align: center
  font-size: 15px
  cursor: pointer
  font-weight: bold
.panel_area
  background: #fff
.tab_panel
  width: 100%
  padding: 80px 0
  display: none
.tab_panel p
  font-size: 14px
  letter-spacing: 1px
  text-align: center
#tab1:checked ~ .tab_area .tab1_label
  background: #00AC3D
  color: #fff
  border-radius: 23px
  padding: 15px
  font-size: 15px
  font-weight: bold
#tab1:checked ~ .panel_area #panel1
display:block
#tab2:checked ~ .tab_area .tab2_label
  background: #00AC3D
  color: #fff
  border-radius: 23px
  padding: 15px
  font-size: 15px
  font-weight: bold
#tab2:checked ~ .panel_area #panel2
  display: block
.leaflet
  margin: 30px 0
  img
    display:inline-block
    vertical-align: middle
    margin: 0 10px
    width: 80px
  .link
    margin: 0 10px
    font-size: 15px
    text-decoration: underline
    color: #00AC3D
    font-weight: bold
.explanation
  margin: 40px 0 0 0
ul
  overflow: hidden
  letter-spacing: -.5em
  margin: 20px 10px
li
  display: inline-block
  width: 50%
  vertical-align: middle
  letter-spacing: 0
  text-align: center
  margin: 0 0 15px 0
  .title
    font-size: 16px
    color: #00AB3D
    margin: 10px 0
    font-weight: bold
  .message
    font-size: 13px
    color: #666
  img
    max-width: 65%
.anytime
  text-align: left
  .title2
    font-size: 16px
    color: #00AB3D
    margin: 10px 0
    font-weight: bold
  .message2
    font-size: 13px
    color: #666
.live-programs
  display: flex
  justify-content: space-between
  flex-wrap: wrap
  .program-wrapper
    width: calc(50% - 10px)
</style>
